<template>
  <div>
    <v-expansion-panels flat multiline>
      <v-expansion-panel>
        <v-expansion-panel-header :id="`${datType}-dat-panel-expand`">
          <span class="dat-type">{{ datType }}</span>
          <template v-slot:actions>
            <AddDatDialogStepper
              v-if="getCurrentUserIsAbleToWrite('dat') && alldats.length >= 0"
              :datType="datType"
              :masterAccount="masterAccount"
              :datnames="getNames()"
              :datids="getIds()"
              :disableAddDat="isDisabled()"
              @saveDat="saveDat($event)"
            />
            <v-icon id="dat-expand-button"> $expand </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <VersionPanelContainer
            v-for="dat in dats"
            :key="dat.id"
            :dat="dat"
            :datnames="getNames()"
            :masterAccount="masterAccount"
            @updateList="updateList"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { INotification, store as datStore } from '@/store/modules/dats/types';
import { store as userPermissionStore } from '@/store/modules/permissions/types';
import { DatRelatedV3 } from 'ctp-toll-domain';
import { MasterAccountInfo } from 'ctp-user-auth-service';
import AddDatDialogStepper from './AddDatDialogStepper.vue';
import VersionPanelContainer from './VersionPanelContainer.vue';

@Component({
  components: {
    AddDatDialogStepper,
    VersionPanelContainer
  }
})
export default class VersionPanel extends Vue {
    @Prop()
    private dats!: DatRelatedV3[];

    @Prop()
    private alldats!: DatRelatedV3[];

    @Prop()
    private datType!: string;

    @Prop()
    private masterAccount!: MasterAccountInfo;

    @datStore.Action
    private createDat!: (payload: any) => Promise<INotification>;

    @datStore.Getter
    private getDatStatus!: (dat: DatRelatedV3) => any;

    private async saveDat(filedata: any) {
      await this.createDat(filedata);
      this.updateList();
    }

    private updateList() {
      this.$emit('updateList');
    }

    @userPermissionStore.Getter
    private getCurrentUserIsAbleTo: (readOrWrite: string, featureName: string) => boolean;

    private getCurrentUserIsAbleToWrite(featureName: string) {
      return featureName ? this.getCurrentUserIsAbleTo('write', featureName) : false;
    }

    getNames() {
      return this.alldats.map((dat: DatRelatedV3) => dat.name);
    }

    getIds() {
      return this.alldats.map((dat: DatRelatedV3) => dat.uid);
    }

    isDisabled() {
      if (this.alldats.length > 0) {
        return this.alldats.filter((dat: DatRelatedV3) => dat.validTo === null).length >= 5;
      }
      return false;
    }
}
</script>

<style lang="scss" scoped>
@import './styles/version-panel.scss';
</style>
